import RetainBooksInPicks from "components/RetainBooksInPicks";
import useSearchParams from "hooks/useSearchParams";
import { Container } from "layouts";
import PaddingX from "layouts/PaddingX";
import { useEffect, useState } from "react";
import { BiCheck } from "react-icons/bi";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import AppDownloadLinks from "components/v2/AppDownloadLinks";

const SubscriptionSuccessResponse = () => {
	const [showListOfPicksToRetain, setShowListOfPicksToRetain] = useState(false);
	const { getParam } = useSearchParams();

	const paymentMethod = getParam("payment_method");
	const hasPicks = getParam("has_picks") === "true" ? true : false;

	useEffect(() => {
		if (hasPicks) {
			setShowListOfPicksToRetain(true);
		} else {
			setShowListOfPicksToRetain(false);
		}

		return () => setShowListOfPicksToRetain(false);
	}, [hasPicks]);

	return (
		<Container>
			<PaddingX>
				<motion.div
					className="mt-10 lg:mt-24 max-w-md mx-auto bg-white rounded-lg p-6"
					initial={{ opacity: 0, y: 20 }}
					animate={{ opacity: 1, y: 0 }}
					transition={{ duration: 0.6 }}
				>
					<div className="flex flex-col justify-center items-center">
						<motion.div
							className="flex justify-center items-center mb-4"
							initial={{ scale: 0.8 }}
							animate={{ scale: 1 }}
							transition={{ duration: 0.5, delay: 0.2 }}
						>
							<div className="bg-green-50 p-4 rounded-full">
								<BiCheck
									size={80}
									className="text-akgreener"
								/>
							</div>
						</motion.div>

						<motion.div
							className="flex flex-col items-center gap-3 text-center w-full"
							initial={{ opacity: 0 }}
							animate={{ opacity: 1 }}
							transition={{ duration: 0.5, delay: 0.4 }}
						>
							<h1 className="text-2xl font-bold text-gray-700">
								Payment Successful!
							</h1>

							<p className="text-gray-600 mb-2">
								Your{" "}
								<span className="font-medium text-akgreener">
									{paymentMethod}
								</span>{" "}
								payment was recorded successfully
							</p>

							<div className="bg-gray-50 p-4 rounded-md w-full">
								<p className="text-gray-700 text-sm">
									Browse{" "}
									<Link
										className="font-medium text-blue-600 hover:text-blue-800"
										to={`/books`}
									>
										books
									</Link>{" "}
									and pick the ones you want to enlist in your subscription.
									When you find a book you like, click the "Add to picks" button
									to enlist it in your subscription.
								</p>
							</div>

							<div className="mt-5 pt-5 border-t border-gray-200 w-full">
								{/* Prominent App Download Section */}
								<AppDownloadLinks compact className="mb-4 text-left" />

								<motion.div
									whileHover={{ scale: 1.03 }}
									transition={{ duration: 0.2 }}
									className="text-center"
								>
									<Link
										to="/books"
										className="px-4 py-2 bg-akgreener text-white font-medium rounded-md transition-all hover:bg-akgreen w-full sm:w-auto inline-block"
									>
										Browse Books Now
									</Link>
								</motion.div>
							</div>
						</motion.div>
					</div>
				</motion.div>

				<RetainBooksInPicks
					showListOfPicksToRetain={showListOfPicksToRetain}
					setShowListOfPicksToRetain={setShowListOfPicksToRetain}
				/>
			</PaddingX>
		</Container>
	);
};

export default SubscriptionSuccessResponse;
